const PaymentMethodRef = require('@/lib/PaymentMethods/PaymentMethodRef');
const PayyoConfig = require('@/lib/PaymentMethods/Payyo/PayyoConfig');
const PayyoDriver = require('@/lib/PaymentMethods/Payyo/PayyoDriver');
const PayyoWebSocketClient = require('@/lib/PaymentMethods/Payyo/PayyoWebSocketClient');

app.factory(
    'payyoConfig',
    /**
     * @param hydrator
     * @param {CurrentDevice} currentDevice
     * @param {PaymentMethodService} paymentMethodService
     */
    function (
        hydrator,
        currentDevice,
        paymentMethodService
    ) {
        let config = new PayyoConfig();
        let device = currentDevice.device;

        let paymentMethod = paymentMethodService.getByRef(PaymentMethodRef.CARD_PAYYO_CHIP_AND_PIN);
        if (!paymentMethod) {
            throw new Error('Company does not have Payyo payment method enabled.');
        }

        // Set config from the company's payment method config.
        if (paymentMethod.config) {
            let companyTerminalConfig = JSON.parse(paymentMethod.config);
            hydrator.hydrate(companyTerminalConfig, config);
        }

        // Set config from the device's payment method config.

        if (device.paymentTerminalConfig) {
            if (device.paymentTerminalConfig.hasOwnProperty(PaymentMethodRef.CARD_PAYYO_CHIP_AND_PIN)) {
                hydrator.hydrate(device.paymentTerminalConfig[PaymentMethodRef.CARD_PAYYO_CHIP_AND_PIN], config);
            }
        }

        console.log('[PayyoConfig]', config);

        return config;
    }
);

app.service('payyoDriver', PayyoDriver);
app.service('payyoWebSocketClient', PayyoWebSocketClient);
